import {
  // Currencies,
  Notifications,
} from '@orbital/games-frontend-library'
import { Currencies } from '../../../../helpers/currency/getCurrencySymbol'
import React, { useEffect, useState, useContext } from 'react'
import { MyContext } from '../../../../context/createContext'
import NumberInput from '../../../elements/NumberInput/NumberInput'
import { Currency } from '../../../elements/NumberInput/NumberInputStyles'
import {
  checkForEmpty,
  checkForLengthAfterDot,
  checkOnlyDot,
  checkRegEx,
  checkStartWithDot,
  checkStartWithZeros,
} from '../../helpers/checkers'
import floorFigure from '../../helpers/floorFigure'
import { regexes } from '../../helpers/regex'

export interface BetInput_props {
  currency: any
  handleStake: any
  maxBet?: any
  minBet?: any
  stake: any
  title: string
  width?: any
  height?: any
  fontSize?: any
  precise: any
  name: string
  handleNotification?: any
}

export default function BetInput({
  stake,
  currency,
  handleStake,
  maxBet,
  minBet,
  title,
  width,
  height,
  fontSize,
  precise,
  name,
  handleNotification,
}: BetInput_props) {
  const { context } = useContext(MyContext)
  const { handleBaseStake, baseStake } = context
  const [stakeValue, setStakeValue] = useState('')
  //TODO make helpers for change and blur
  const handleChange = (e: any) => {
    const value = e.target.value
    if (checkRegEx(value, regexes.numbersDotComma)) {
      setStakeValue(value.replace(/,/g, '.'))
    }
  }
  const handleBlur = (s: any) => {
    const value = s.target.value
    if (value <= +minBet) {
      const newStake = Number(+minBet).toFixed(precise)
      return handleStakeUpdate(name, newStake, precise)
    }
    if (checkForEmpty(value) || checkOnlyDot(value) || Number(value) === 0) {
      if (name === 'STAKE') {
        return handleStakeUpdate(name, +minBet, precise)
      }

      return handleStakeUpdate(name, '0', precise)
    }
    if (value > +maxBet) {
      if (name === 'STAKE') {
        handleBaseStake(floorFigure(maxBet, precise))
      }
      return (
        handleStakeUpdate(name, maxBet, precise),
        precise &&
          handleNotification(
            Notifications.maxStake +
              maxBet.toFixed(precise) +
              Currencies[currency].symbol,
          )
      )
    }
    if (checkStartWithDot(value)) {
      if (checkForLengthAfterDot(value, precise)) {
        return handleStakeUpdate(name, stakeValue, precise)
      } else {
        return handleStakeUpdate(name, minBet, precise)
      }
    }
    if (checkForLengthAfterDot(value, precise)) {
      return handleStakeUpdate(name, stakeValue, precise)
    }
    return handleStakeUpdate(name, value, precise)
  }

  useEffect(() => {
    setStakeValue(floorFigure(stake, precise))
    handleStake(floorFigure(stake, precise), name)
    if (name === 'STAKE' && handleBaseStake) {
      handleBaseStake(stake)
    }
  }, [stake])

  const handleStakeUpdate = (name: string, value: any, precise: any) => {
    if (name === 'STAKE') {
      handleBaseStake(value)
    }
    handleStake(floorFigure(value, precise), name)
    setStakeValue(floorFigure(value, precise))
  }

  return (
    <NumberInput
      value={stakeValue}
      handleBlur={handleBlur}
      handleChange={handleChange}
      title={title}
      placeholder={minBet}
      fontSize={fontSize}
      width={width || '120px'}
      height={height || '50px'}
      padding='7px 10px'
      h='24px'
      inputMode='decimal'
      name='bet'
    >
      <Currency fontSize={fontSize}>
        {Currencies[currency] && Currencies[currency].symbol}
      </Currency>
    </NumberInput>
  )
}
